const TopbarNavigationMenuConfig = {
    default: {
        forTopbarTemplates: [
            'topbar1',
            'topbar2',
            'topbar3',
            'topbar4',
            'topbar5',
        ],
        loggedOut: {
            menus: [
                {
                    name: 'single-menu',
                    menuItems: [
                        {
                            "id": "menuItem6",
                            "label": "Home",
                            "inHamburger": true,
                            "linkData": {
                                "linkType": "pagelink",
                                "linkTo": "home",
                                "linkToExtra": "",
                                "linkOpen": "default",
                                "href": "/pages/home",
                            },
                            "subItems": []
                        },
                        {
                            "id": "menuItem7",
                            "label": "Courses",
                            "inHamburger": true,
                            "linkData": {
                                "linkType": "pagelink",
                                "linkTo": "courses",
                                "linkToExtra": "",
                                "linkOpen": "default",
                                "href": "/pages/courses",
                            },
                            "linked": true,
                            "subItems": []
                        },
                        {
                            "id": "menuItem8",
                            "label": "Contact Us",
                            "inHamburger": true,
                            "linkData": {
                                "linkType": "pagelink",
                                "linkTo": "contact",
                                "linkToExtra": "",
                                "linkOpen": "default",
                                "href": "/pages/contact",
                            },
                            "subItems": []
                        },
                        {
                            "id": "menuItem_1592487994826_6",
                            "inHamburger": true,
                            "label": "About us",
                            "linkData": {
                                "linkOpen": "default",
                                "linkTo": "about",
                                "linkToExtra": "",
                                "linkType": "pagelink",
                                "href": "/pages/about",
                            },
                            "subItems": []
                        },
                        {
                            "id": "menuItem5",
                            "label": "Sign in",
                            "inHamburger": true,
                            "linkData": {
                                "linkTo": "signin",
                                "linkType": "openformslink",
                                "href": false,
                            },
                            "appearance": "roundedOutline",
                            "subItems": []
                        }
                    ],
                }
            ],
        },
        loggedIn: {
            menus: [
                {
                    name: 'single-menu',
                    menuItems: [
                        {
                            "id": "menuItem10",
                            "inHamburger": true,
                            "label": "Start",
                            "linkData": {
                                "linkOpen": "default",
                                "linkTo": "start",
                                "linkToExtra": "",
                                "linkType": "pagelink",
                                "href": "/pages/start",
                            },
                            "subItems": []
                        },
                        {
                            "id": "menuItem9",
                            "inHamburger": true,
                            "label": "Courses",
                            "linkData": {
                                "linkOpen": "default",
                                "linkTo": "courses",
                                "linkToExtra": "",
                                "linkType": "pagelink",
                                "href": "/pages/courses",
                            }
                        },
                        {
                            "id": "menuItem11",
                            "inHamburger": true,
                            "label": "Community",
                            "linkData": {
                                "linkOpen": "default",
                                "linkTo": "social",
                                "linkToExtra": "",
                                "linkType": "appslink",
                                "href": "/social",
                            },
                            "subItems": []
                        },
                        {
                            "id": "menuItem12",
                            "appearance": "",
                            "label": "Apps",
                            "linkData": {},
                            "subItems": [
                                {
                                    "id": "menuItem13",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Daily News",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "dailynews",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/dailynews",
                                    }
                                },
                                {
                                    "id": "menuItem14",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Best Resources",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "workpad",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/workpad",
                                    }
                                },
                                {
                                    "id": "menuItem15",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Other Students",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "people",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/people",
                                    }
                                }
                            ]
                        },
                        {
                            "id": "menuItem16",
                            "appearance": "",
                            "label": "Me",
                            "linkData": {},
                            "subItems": [
                                {
                                    "id": "menuItem17",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Inbox",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "inbox",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/inbox",
                                    }
                                },
                                {
                                    "id": "menuItem18",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Profile",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "profile",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/profile",
                                    }
                                },
                                {
                                    "id": "menuItem19",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Account",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "account",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/account",
                                    }
                                },
                                {
                                    "id": "menuItem20",
                                    "appearance": "textOnlyAccent1",
                                    "inHamburger": true,
                                    "label": "Sign out",
                                    "linkData": {
                                        "linkType": "signout",
                                        "href": false,
                                    }
                                }
                            ]
                        }
                    ],
                }
            ],
        },
    },
    splitMenus: {
        forTopbarTemplates: [
            'topbar6',
            'topbar7',
        ],
        loggedOut: {
            menus: [
                {
                    name: 'left-menu',
                    menuItems: [
                        {
                            "id": "menuItem6",
                            "label": "Home",
                            "inHamburger": true,
                            "linkData": {
                                "linkType": "pagelink",
                                "linkTo": "home",
                                "linkToExtra": "",
                                "linkOpen": "default",
                                "href": "/pages/home",
                            },
                            "subItems": []
                        },
                        {
                            "id": "menuItem7",
                            "label": "Courses",
                            "inHamburger": true,
                            "linkData": {
                                "linkType": "pagelink",
                                "linkTo": "courses",
                                "linkToExtra": "",
                                "linkOpen": "default",
                                "href": "/pages/courses",
                            },
                            "linked": true,
                            "subItems": []
                        },
                        {
                            "id": "menuItem8",
                            "label": "Contact Us",
                            "inHamburger": true,
                            "linkData": {
                                "linkType": "pagelink",
                                "linkTo": "contact",
                                "linkToExtra": "",
                                "linkOpen": "default",
                                "href": "/pages/contact",
                            },
                            "subItems": []
                        },
                        {
                            "id": "menuItem_1592487994826_6",
                            "inHamburger": true,
                            "label": "About us",
                            "linkData": {
                                "linkOpen": "default",
                                "linkTo": "about",
                                "linkToExtra": "",
                                "linkType": "pagelink",
                                "href": "/pages/about",
                            },
                            "subItems": []
                        }
                    ]
                },
                {
                    name: 'right-menu',
                    menuItems: [
                        {
                            "id": "menuItem5",
                            "label": "Sign in",
                            "inHamburger": true,
                            "linkData": {
                                "linkTo": "signin",
                                "linkType": "openformslink",
                                "href": false,
                            },
                            "appearance": "",
                            "subItems": []
                        },
                        {
                            "id": "menuItem19",
                            "label": "Sign up",
                            "inHamburger": true,
                            "linkData": {
                                "linkTo": "signup",
                                "linkType": "openformslink",
                                "href": false,
                            },
                            "appearance": "roundedOutline",
                            "subItems": []
                        }
                    ]
                }
            ]
        },
        loggedIn: {
            menus: [
                {
                    name: 'left-menu',
                    menuItems: [
                        {
                            "id": "menuItem9",
                            "inHamburger": true,
                            "label": "Courses",
                            "linkData": {
                                "linkOpen": "default",
                                "linkTo": "courses",
                                "linkToExtra": "",
                                "linkType": "pagelink",
                                "href": "/pages/courses",
                            }
                        },
                        {
                            "id": "menuItem10",
                            "inHamburger": true,
                            "label": "After login",
                            "linkData": {
                                "linkOpen": "default",
                                "linkTo": "start",
                                "linkToExtra": "",
                                "linkType": "pagelink",
                                "href": "/pages/start",
                            },
                            "subItems": []
                        },
                        {
                            "id": "menuItem11",
                            "inHamburger": true,
                            "label": "Community",
                            "linkData": {
                                "linkOpen": "default",
                                "linkTo": "social",
                                "linkToExtra": "",
                                "linkType": "appslink",
                                "href": "/social",
                            },
                            "subItems": []
                        },
                        {
                            "id": "menuItem12",
                            "appearance": "",
                            "label": "Apps",
                            "linkData": {},
                            "subItems": [
                                {
                                    "id": "menuItem13",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Daily News",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "dailynews",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/dailynews",
                                    }
                                },
                                {
                                    "id": "menuItem14",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Best Resources",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "workpad",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/workpad",
                                    }
                                },
                                {
                                    "id": "menuItem15",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Other Students",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "people",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/people",
                                    }
                                }
                            ]
                        },
                        {
                            "id": "menuItem16",
                            "appearance": "",
                            "label": "Me",
                            "linkData": {},
                            "subItems": [
                                {
                                    "id": "menuItem17",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Inbox",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "inbox",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/inbox",
                                    }
                                },
                                {
                                    "id": "menuItem18",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Profile",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "profile",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/profile",
                                    }
                                },
                                {
                                    "id": "menuItem19",
                                    "appearance": "",
                                    "inHamburger": true,
                                    "label": "Account",
                                    "linkData": {
                                        "linkType": "appslink",
                                        "linkTo": "account",
                                        "linkToExtra": "",
                                        "linkOpen": "default",
                                        "href": "/account",
                                    }
                                },
                            ]
                        }
                    ]
                },
                {
                    name: 'right-menu',
                    menuItems: [
                        {
                            "id": "menuItem20",
                            "appearance": "roundedOutline",
                            "inHamburger": true,
                            "label": "Sign out",
                            "linkData": {
                                "linkType": "signout",
                                "href": false,
                            }
                        },
                    ]
                },
            ],
        }
    }
}

export {TopbarNavigationMenuConfig};
